(() => {
  'use strict';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const endpoint = path => root.replace(/\/?$/, '/') + path;
  const drawer = document.querySelector('.cart-drawer');
  const backdrop = document.querySelector('.drawer-backdrop');
  const cartItems = document.querySelector('.cart-items');
  const toast = document.querySelector('.toast');
  let activeCart = null;
  let previousFocus = null;
  let toastTimer;

  const currencyCode = () => activeCart?.currency || window.Shopify?.currency?.active || document.querySelector('[data-product-section]')?.dataset.currency || 'USD';
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: currencyCode()}).format(cents / 100); }
    catch (_) { return '$' + (cents / 100).toFixed(2); }
  };
  const announce = message => {
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 4500);
  };
  async function request(path, options = {}) {
    const response = await fetch(endpoint(path), {credentials: 'same-origin', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Could not update your bag. Please try again.');
    return data;
  }
  const jsonPost = (path, body) => request(path, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
  async function refreshCart() { activeCart = await request('cart.js'); renderCart(); }

  function renderCart() {
    if (!activeCart) return;
    document.querySelectorAll('.cart-count').forEach(node => node.textContent = activeCart.item_count);
    document.querySelectorAll('[data-open-cart]').forEach(node => node.setAttribute('aria-label', `Open bag, ${activeCart.item_count} ${activeCart.item_count === 1 ? 'item' : 'items'}`));
    document.querySelector('.cart-count-inline').textContent = `(${activeCart.item_count})`;
    document.querySelector('.subtotal-value').textContent = money(activeCart.total_price);
    cartItems.replaceChildren();
    if (!activeCart.item_count) {
      const empty = document.createElement('div');
      empty.className = 'cart-empty';
      const title = document.createElement('h3'); title.textContent = 'Your bag is taking a little break.';
      const note = document.createElement('p'); note.textContent = 'Meet your new morning step.';
      const link = document.createElement('a'); link.className = 'button button-outline'; link.href = root; link.textContent = 'CONTINUE SHOPPING ↗';
      empty.append(title, note, link); cartItems.append(empty);
      return;
    }
    for (const item of activeCart.items) {
      const line = document.createElement('article'); line.className = 'cart-line';
      const image = document.createElement('img'); image.src = item.image || drawer.dataset.fallbackImage; image.alt = item.product_title || item.title || 'Product'; image.loading = 'lazy';
      const content = document.createElement('div');
      const title = document.createElement('h3'); title.textContent = item.product_title || item.title;
      const option = document.createElement('p'); option.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '10G / 0.35OZ';
      const price = document.createElement('strong'); price.textContent = money(item.final_line_price);
      const controls = document.createElement('div'); controls.className = 'line-controls';
      const quantity = document.createElement('div'); quantity.className = 'quantity-control';
      for (const [action, symbol, label] of [['decrease','−','Decrease'], ['increase','+','Increase']]) {
        if (action === 'increase') { const out = document.createElement('output'); out.textContent = item.quantity; quantity.append(out); }
        const button = document.createElement('button'); button.type = 'button'; button.dataset.cartAction = action; button.dataset.key = item.key; button.textContent = symbol; button.setAttribute('aria-label', `${label} quantity for ${item.product_title || item.title}`); quantity.append(button);
      }
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'remove-line'; remove.dataset.cartAction = 'remove'; remove.dataset.key = item.key; remove.textContent = 'REMOVE';
      controls.append(quantity, remove); content.append(title, option, price, controls); line.append(image, content); cartItems.append(line);
    }
  }
  function closeCart() {
    drawer.hidden = true; backdrop.hidden = true; document.body.classList.remove('locked');
    if (previousFocus?.isConnected) previousFocus.focus();
  }
  async function openCart(trigger = document.activeElement) {
    previousFocus = trigger;
    drawer.hidden = false; backdrop.hidden = false; document.body.classList.add('locked');
    drawer.querySelector('.close-cart').focus();
    try { await refreshCart(); } catch (error) { announce(error.message); }
  }
  document.querySelectorAll('[data-open-cart]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); openCart(link); }));
  drawer.querySelector('.close-cart').addEventListener('click', closeCart);
  drawer.querySelector('.continue-shopping').addEventListener('click', closeCart);
  backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', event => {
    if (drawer.hidden) return;
    if (event.key === 'Escape') { closeCart(); return; }
    if (event.key === 'Tab') {
      const focusable = [...drawer.querySelectorAll('button:not(:disabled),a[href]')];
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  cartItems.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-action]'); if (!button || !activeCart) return;
    const item = activeCart.items.find(line => line.key === button.dataset.key); if (!item) return;
    const quantity = button.dataset.cartAction === 'remove' ? 0 : Math.max(0, item.quantity + (button.dataset.cartAction === 'increase' ? 1 : -1));
    button.disabled = true;
    try { activeCart = await jsonPost('cart/change.js', {id: item.key, quantity}); renderCart(); }
    catch (error) { announce(error.message); button.disabled = false; }
  });

  const toggle = document.querySelector('.menu-toggle'), mobileNav = document.querySelector('.mobile-nav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); mobileNav.hidden = !open;
  });
  mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { mobileNav.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }));

  function initProduct(scope = document) {
    const productSection = scope.querySelector('[data-product-section]');
    if (!productSection || productSection.dataset.initialized === 'true') return;
    productSection.dataset.initialized = 'true';
    const sectionWrapper = productSection.closest('.shopify-section') || document;
    const form = productSection.querySelector('.purchase-form');
    const variantInput = form.querySelector('[name="id"]');
    const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    const bundleButtons = [...form.querySelectorAll('[data-bundle]')];
    const bundlePicker = form.querySelector('[data-bundle-picker]');
    let bundle = 1, sets = 1;
    const selectedVariant = () => variants.find(variant => String(variant.id) === String(variantInput.value));
    const bundleTotal = (unitPrice, tubes) => {
      const discount = tubes >= 3 ? 0.8 : tubes === 2 ? 0.9 : 1;
      return Math.round(unitPrice * tubes * discount);
    };
    const update = () => {
      const variant = selectedVariant(); if (!variant) return;
      const tubes = bundle * sets;
      const total = bundleTotal(variant.price, tubes);
      form.querySelector('[data-variant-price]').textContent = money(variant.price);
      form.querySelector('[data-availability]').textContent = variant.available ? 'AVAILABLE' : 'SOLD OUT';
      bundleButtons.forEach(button => {
        button.querySelector('[data-bundle-price]').textContent = money(bundleTotal(variant.price, Number(button.dataset.bundle)));
      });
      bundlePicker.hidden = sets > 1;
      form.querySelector('[data-quantity-label]').textContent = sets > 1 ? 'NUMBER OF TUBES' : 'QUANTITY';
      form.querySelector('[data-product-quantity]').setAttribute('aria-label', sets > 1 ? 'Number of tubes' : 'Quantity');
      form.querySelector('.quantity-value').textContent = sets;
      form.querySelector('.quantity-minus').disabled = sets <= 1;
      form.querySelector('[data-total-quantity]').value = String(tubes);
      form.querySelector('[data-selection-price]').textContent = money(total);
      sectionWrapper.querySelector('[data-mobile-price]').textContent = money(total);
      form.querySelector('[data-add-label]').textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      form.querySelector('.add-to-cart').disabled = !variant.available;
      sectionWrapper.querySelector('.mobile-add-to-cart').disabled = !variant.available;
    };
    variantInput.addEventListener('change', update);
    bundleButtons.forEach(button => button.addEventListener('click', () => {
      bundle = Number(button.dataset.bundle);
      bundleButtons.forEach(other => { const chosen = other === button; other.classList.toggle('selected', chosen); other.setAttribute('aria-pressed', String(chosen)); });
      update();
    }));
    form.querySelector('.quantity-minus').addEventListener('click', () => { sets = Math.max(1, sets - 1); update(); });
    form.querySelector('.quantity-plus').addEventListener('click', () => {
      if (sets === 1) {
        bundle = 1;
        bundleButtons.forEach(button => {
          const chosen = Number(button.dataset.bundle) === 1;
          button.classList.toggle('selected', chosen);
          button.setAttribute('aria-pressed', String(chosen));
        });
      }
      sets = Math.min(99, sets + 1);
      update();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const variant = selectedVariant(); if (!variant?.available) return;
      const button = form.querySelector('.add-to-cart'); button.disabled = true;
      try {
        await jsonPost('cart/add.js', {items: [{id: Number(variant.id), quantity: bundle * sets}]});
        await openCart(button);
      } catch (error) { announce(error.message); }
      finally { button.disabled = !selectedVariant()?.available; }
    });
    sectionWrapper.querySelector('.mobile-add-to-cart').addEventListener('click', () => form.requestSubmit());
    const mainImage = productSection.querySelector('[data-gallery-image]');
    productSection.querySelectorAll('.gallery-thumb').forEach(button => button.addEventListener('click', () => {
      mainImage.src = button.dataset.image; mainImage.alt = button.dataset.alt;
      productSection.querySelectorAll('.gallery-thumb').forEach(other => { const chosen = other === button; other.classList.toggle('selected', chosen); other.setAttribute('aria-pressed', String(chosen)); });
    }));
    update();
  }
  initProduct();
  document.addEventListener('shopify:section:load', event => initProduct(event.target));
  refreshCart().catch(() => {});
})();